const phoneInputs = document.querySelectorAll('.js-c-form-input--phone')
phoneInputs.forEach(initPhoneInput)

function initPhoneInput(input) {
  // TODO: Seperate from Jquery
  const $mobileInput = $(input)
  $mobileInput.intlTelInput({
    initialCountry: 'AU',
    formatOnInit: true,
    hiddenInput: $mobileInput.prop('name'),
    autoPlaceholder: 'off'
  })
}
